import React from 'react';

import SessionContext from './SessionContext';

export default function withSessionInfo(Component, { as = 'session' } = {}) {
  function enhance(props, session) {
    return { ...props, [as]: session };
  }

  function Wrapper(props) {
    return (
      <SessionContext.Consumer>
        {session => <Component {...enhance(props, session)} />}
      </SessionContext.Consumer>
    );
  }

  const componentName = Component.displayName || Component.name;
  Wrapper.displayName = `withSessionInfo(${componentName})`;

  return Wrapper;
}
